import styles from "./Field.module.css";
import PropTypes from "prop-types";
import Fieldset from "./Fieldset";

export default function Field({
  children,
  errorList = [],
  id,
  labelAlignment,
  labelText,
}) {
  return (
    <Fieldset errorList={errorList}>
      <label
        className={styles.label}
        htmlFor={id}
        style={{
          "--alignment": `${labelAlignment}`,
        }}
      >
        {labelText}
      </label>
      {children}
    </Fieldset>
  );
}

Field.propTypes = {
  children: PropTypes.node.isRequired,
  errorList: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string.isRequired,
  labelAlignment: PropTypes.string,
  labelText: PropTypes.string.isRequired,
};
